(function () {
    'use strict';

    angular
      .module('services.historyCtxt', [])
      .provider('historyCtxtService', provider);

    function provider() {

        // Context State Templates Urls
        // state => templateUrl
        var ctxtStateTemplateUrls = {};

        // State Params Config 
        var stateParamsConfig = {
            ctxStateName: { value: undefined },
            ctxStateParams: { value: undefined },
            ctxItem: { value: undefined },
            ctxtHash: { value: undefined },
            ctxtBreadcrumbTitle: { value: undefined },
            ctxtBreadcrumbIcon: { value: undefined }
        };

        // Get State Params Config
        this.getStateParamsConfig = function () {
            return stateParamsConfig;
        };

        // Set Context State
        this.setCtxtState = function (stateName, templateUrl) {
            ctxtStateTemplateUrls[stateName] = templateUrl;
        };

        // Service
        this.$get = ['$state', '$stateParams', '$location', function ($state, $stateParams, $location) {

            return {
                getCtxName: getCtxName,
                setCtxName: setCtxtName,
                getCtxItem: getCtxItem,
                setCtxItem: setCtxItem,
                getCtxtTemplateUrl: getCtxtTemplateUrl,
                goToContext: goToContext,
                goToState: goToState,
                hasContext: hasContext,
                setContextAsDefault: setContextAsDefault,
                goToStateWithDefaultContext: goToStateWithDefaultContext,
                goToStateWithOptions: goToStateWithOptions,
                reload: reload
            };

            // Get Context State Name
            function getCtxName() {
                return $stateParams.ctxStateName;
            }

            // Set Context State Name
            function setCtxtName(stateName) {
                $stateParams.ctxStateName = stateName;
            }

            // Get Context Item
            function getCtxItem() {
                return $stateParams.ctxItem;
            }

            // Set Context Item
            function setCtxItem(item) {
                $stateParams.ctxItem = item;
            }

            // Get Context Template Url
            function getCtxtTemplateUrl() {
                return ctxtStateTemplateUrls[$stateParams.ctxStateName];
            }

            // Go To Context
            function goToContext() {

                if ($stateParams.ctxtHash) {
                    var path = $state.href($stateParams.ctxStateName, $stateParams.ctxStateParams);
                    $location.url(path + '#' + $stateParams.ctxtHash);
                    return;
                }

                var stateParams = _.cloneDeep($stateParams);

                if ($stateParams.isDefaultContext) {
                    $stateParams.ctxStateName = undefined;
                    $stateParams.ctxStateParams = undefined;
                    $stateParams.ctxItem = undefined;
                    $stateParams.isDefaultContext = false;
                }

                $state.go(stateParams.ctxStateName, stateParams.ctxStateParams);
            }

            // Has Context?
            function hasContext() {
                return !_.isUndefined($stateParams.ctxStateName)
            }

            // Go To State
            function goToState(toStateName, toStateParams, ctxStateName, ctxItem) {

                var mergedParams = _.assign(toStateParams, {
                    ctxStateName: ctxStateName,
                    ctxStateParams: _.cloneDeep($stateParams),
                    ctxItem: _.cloneDeep(ctxItem)
                });

                $state.go(toStateName, mergedParams);
            }

            // Go To State With Default Context
            function goToStateWithDefaultContext(toStateName, toStateParams) {

                $stateParams.ctxStateName = undefined;
                $stateParams.ctxStateParams = undefined;
                $stateParams.ctxItem = undefined;

                setContextAsDefault();

                $state.go(toStateName, toStateParams);
            }
            
            // Set Context As Default
            function setContextAsDefault() {
                $stateParams.isDefaultContext = true;
            }

            /**
             * Same as goToState except you can pass extra parameters.
             *
             * @param {string} toStateName - State to go to
             * @param {object} args - Contains different parameters that can be set
             * @param {object} args.toStateParams - Parameters to set to $state.go
             * @param {string} args.ctxStateName - State to set in context
             * @param {object} [args.ctxItem] - Object made available for the context
             * @param {object} [args.ctxtHash] - Hash value to apply when returning to the context state
             * @param {object} [args.options] - Options to pass to $state.go
             * @param {object} [args.ctxtBreadcrumbTitle] - Title of the contextual breadcrumb element
             * @param {object} [args.ctxtBreadcrumbIcon] - Icon of the contextual breadcrumb element
             */
            function goToStateWithOptions(toStateName, args) {
                var mergedParams = _.assign(args.toStateParams, {
                    ctxStateName: args.ctxStateName,
                    ctxStateParams: _.cloneDeep($stateParams),
                    ctxItem: _.cloneDeep(args.ctxItem),
                    ctxtHash: args.ctxtHash,
                    ctxtBreadcrumbTitle: args.ctxtBreadcrumbTitle,
                    ctxtBreadcrumbIcon: args.ctxtBreadcrumbIcon
                });

                $state.go(toStateName, mergedParams, args.options);
            }

            /**
             * Reload current state while keeping the context.
             * By default this replaces the state in the browser history.
             */
            function reload() {
                $state.go($state.current.name, $stateParams, {reload: true});
            }
        }];
    }
})();